import { Card, Input, Select, Tag, Tooltip } from "antd";
import React, { useState } from "react";
import {
  SearchOutlined,
  SyncOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import Invitation from "./Invitation";
import { ADMIN_DOWNLOAD_USER, ADMIN_DOWNLOAD_USER_2 } from "../../../API/url";

export default function TabSearch() {
  const dispatch = useDispatch();
  const [isInvite, setInvite] = useState(false);
  const {tabSearchMU, reloadMU, drawerOpenMU, updatePageSizeMU} = bindActionCreators(Actions, dispatch)
  const manageUserState = useSelector(state=>state.manageUsers);
  const adminFilterState = useSelector((state) => state.cmRoot);
  
  const onClickInvite = ()=>{
    setInvite(!isInvite);
  }
  const downloadUser = ()=>{
    let link = ADMIN_DOWNLOAD_USER_2(
        manageUserState.sortfilter,
        manageUserState.sortorder,
        manageUserState.search,
        adminFilterState.selectedRouting.value==='All'?'':adminFilterState.selectedRouting.id,
        adminFilterState.selectedRouting.value==='All'?'':adminFilterState.selectedGeoLevel?.length === 0? "": adminFilterState.selectedGeoLevel.value,
        manageUserState.userType.value ==='all'?'':manageUserState.userType.value,
        manageUserState.role.value ==='all'?'':manageUserState.role.value,
        manageUserState.fromdate===""?'':new Date(manageUserState.fromdate).getTime(),
        manageUserState.tilldate===""?'':new Date(manageUserState.tilldate).getTime(),
        manageUserState.domainFilter?.length===0?'':manageUserState.domainFilter.map(dm=>dm.value).toString(),
        manageUserState.statusValue.value ==='all'?'':manageUserState.statusValue.value,
        manageUserState.activefromdate===""?'':new Date(manageUserState.activefromdate).getTime(),
        manageUserState.activetilldate===""?'':new Date(manageUserState.activetilldate).getTime(),
    );
    
        window.open(link, '_blank');
  }
  return (
    <>
    <div
      className="mt-2"
      style={{
        border: "1px solid #fafafa",
        borderRadius: "6px",
        display: "flex",
        background: "#fafafa",
        padding: "10px",
        boxShadow: "7px 7px 20px lightgrey",
        alignItems: "center",
      }}
    >
      <div style={{ width: "70%", display: "flex", alignItems: "center" }}>
        <div
          style={{
            fontSize: "20px",
            display: "flex",
            alignItems: "center",
            fontWeight: "500",
          }}
        >
          Vizerto Users&nbsp;
          <span
            style={{
              fontSize: "16px",
              border: "1px solid darkgrey",
              background: "darkgrey",
              color: "#fff",
              paddingInline: "5px",
              borderRadius: "4px",
            }}
          >
            {manageUserState.users.length}/{manageUserState.totalCount}
          </span>
          &nbsp;&nbsp;&nbsp;
        </div>
        <div style={{ width: "20%" }}>
          <Input
            allowClear
            value={manageUserState.search}
            onChange={(e)=>tabSearchMU(e.target.value)}
            prefix={<SearchOutlined />}
            placeholder="Search for users..."
          />
        </div>
      </div>
      <div
        style={{
          width: "30%",
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
        }}
      >
        <div style={{ width: "120px", marginRight: "15px" }}>
          <Select
            value={manageUserState.pageSize}
            onChange={(value) => updatePageSizeMU(value)}
            style={{ width: "100%" }}
            options={[
              { value: 10, label: "10 / page" },
              { value: 25, label: "25 / page" },
              { value: 50, label: "50 / page" },
            ]}
          />
        </div>
        {/* <button style={{border:'1px solid var(--light_color_shade)', background:'var(--light_color_shade)', color:'#fff', borderRadius:'4px'}}>Invite users</button> */}
        <Tooltip title={()=>{
          return(
            <span style={{color:'black'}}>Download Users</span>
          )
        }} color="#FFF">
        <i className="fa fa-download" style={{fontSize: "22px", color:'grey', cursor: "pointer"}} onClick={()=>downloadUser()}></i>
        </Tooltip>
      &nbsp;&nbsp;&nbsp;
        {/* <button style={{border:'1px solid var(--light_color_shade)', background:'var(--light_color_shade)', color:'#fff', borderRadius:'4px'}}>Invite users</button> */}
        <Tooltip title={()=>{
          return(
            <span style={{color:'black'}}>Invite Users</span>
          )
        }} color="#FFF">
        <i className="fa fa-paper-plane-o" style={{fontSize: "20px", color:'grey', cursor: "pointer"}} onClick={()=>setInvite(!isInvite)}></i>
        </Tooltip>
      &nbsp;&nbsp;&nbsp;
      <Tooltip title={()=>{
          return(
            <span style={{color:'black'}}>Refresh</span>
          )
        }} color="#FFF">
      <SyncOutlined spin={manageUserState.isLoading} style={{ fontSize: "20px", color:'grey', cursor: "pointer"}} onClick={()=>reloadMU()} />
      </Tooltip>
        &nbsp;
        <Tooltip title={()=>{
          return(
            <span style={{color:'black'}}>Filter List</span>
          )
        }} color="#FFF">
        <FilterListIcon
          style={{ color: "grey", cursor: "pointer", fontSize: "30px" }}
          onClick={()=>drawerOpenMU(1)}
        />
        </Tooltip>
      </div>
    </div>
    {isInvite && <div className="mt-3">
      <Invitation isInvite={onClickInvite}/>
    </div>}
    </>
  );
}
